import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Monitor } from "lucide-react";

const MobileRouteFallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const desktopPath = location.pathname.replace(/^\/m\//, "/");

  const goDesktop = () => navigate(desktopPath);
  const goBack = () => navigate(-1);

  return (
    <div className="mobile-fallback">
      <div className="mobile-fallback-content">
        <div className="mobile-fallback-icon">
          <Monitor size={40} strokeWidth={1.5} />
        </div>
        <h2 className="mobile-fallback-title">Better on desktop</h2>
        <p className="mobile-fallback-desc">
          This module is being optimized for mobile. It works best in a desktop browser.
        </p>
        <button type="button" className="mobile-fallback-btn-primary" onClick={goDesktop}>
          Open on desktop
        </button>
        <button type="button" className="mobile-fallback-btn-secondary" onClick={goBack}>
          Go back
        </button>
      </div>
    </div>
  );
};

export default MobileRouteFallback;
